var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav",class:{ open: _vm.open }},[_c('div',{staticClass:"nav__title",on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._t("title")],2),_c('div',{staticClass:"nav__list"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }